<span class="go-pill">
  <ng-content></ng-content>
  <go-icon
    *ngIf="removable"
    (click)="onClick()"
    icon="close"
    class="go-pill__remove-icon"
  ></go-icon>
</span>
